import type { CSSProperties, ReactNode } from 'react';
import { C } from '@/theme/tokens';

export interface SectionLabelProps {
  children: ReactNode;
  style?: CSSProperties;
}

/** Small all-caps Cinzel label that introduces each section. */
export function SectionLabel({ children, style }: SectionLabelProps) {
  return (
    <p
      style={{
        fontFamily: "'Cinzel',serif",
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: '4px',
        textTransform: 'uppercase',
        color: C.bronze,
        marginBottom: 12,
        ...style,
      }}
    >
      {children}
    </p>
  );
}
